import { STATUS_LABELS } from '../../netlify/functions/lib/bug-management/statuses'
import './StatusBadge.css'

interface StatusBadgeProps {
  status: string
  variant?: 'default' | 'severity' | 'bug'
}

export default function StatusBadge({ status, variant = 'default' }: StatusBadgeProps) {
  const label = STATUS_LABELS[status] ?? status.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
  const className = `status-badge status-badge--${variant}-${status.toLowerCase().replace(/\s+/g, '-')}`

  return (
    <span className={className} data-testid={`status-badge-${status}`}>
      {label}
    </span>
  )
}
